import React from 'react';
import { Switch, Typography } from 'antd';
import { modes } from '../../constants/modes';
import { toggleOwner } from '../../store/actions/calendarActions';
import styles from './ToggleOwner.module.scss';
import { views } from '../../constants/views';
import { useCalendarDispatch, useCalendarState } from '../../context/CalendarContext';

const { Text } = Typography;

const ToggleOwner = () => {
  const dispatch = useCalendarDispatch();
  const { mode, showOwner, view } = useCalendarState();

  if (mode === modes.calendar && (view === views.week || view === views.month)) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Switch
        size="small"
        checked={showOwner}
        onChange={() => dispatch(toggleOwner())}
      />
      <Text>{showOwner ? 'Скрыть собственника' : 'Показать собственника'}</Text>
    </div>
  );
};

export default ToggleOwner;
